module.exports = __webpack_public_path__ + "05c2dd135eda7cd9e84a565b38a4b4ca.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Bold-Oblique.woff
// module id = 390
// module chunks = 0